import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/pages/conversation/assets/images/chevron-up.svg'
import _imports_1 from '@/pages/conversation/assets/images/chevron-down.svg'


const _withScopeId = n => (_pushScopeId("data-v-a91f8254"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "topic-card-header" }
const _hoisted_2 = { class: "topic-card-header-top" }
const _hoisted_3 = { class: "topic-card-header-bottom" }
const _hoisted_4 = { class: "topic-card-header-top" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "topic-card-header-bottom" }, "Responses", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Responses Breakdown", -1))
const _hoisted_8 = {
  key: 0,
  src: _imports_0
}
const _hoisted_9 = {
  key: 1,
  src: _imports_1
}
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "topic-card-all-responses" }
const _hoisted_12 = { class: "topic-card-breakdown" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "topic-card-circle positive" }, " ⬤ ", -1))
const _hoisted_14 = { class: "topic-card-breakdown-count-container" }
const _hoisted_15 = { class: "topic-card-breakdown-count" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "topic-card-circle neutral" }, " ⬤ ", -1))
const _hoisted_17 = { class: "topic-card-breakdown-count-container" }
const _hoisted_18 = { class: "topic-card-breakdown-count" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "topic-card-circle negative" }, " ⬤ ", -1))
const _hoisted_20 = { class: "topic-card-breakdown-count-container" }
const _hoisted_21 = { class: "topic-card-breakdown-count" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UpDownArrow = _resolveComponent("UpDownArrow")!
  const _component_BaseCard = _resolveComponent("BaseCard")!

  return (_openBlock(), _createBlock(_component_BaseCard, { class: "topic-card" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_2, [
            _createTextVNode(_toDisplayString(_ctx.score) + " ", 1),
            (_ctx.scoreChange !== 0)
              ? (_openBlock(), _createBlock(_component_UpDownArrow, {
                  key: 0,
                  positive: _ctx.scoreChange > 0,
                  class: "change"
                }, null, 8, ["positive"]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.questionType), 1)
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.topicResponseCount), 1),
          _hoisted_5
        ])
      ]),
      _hoisted_6,
      _createElementVNode("div", null, [
        _createElementVNode("div", null, [
          _createElementVNode("div", {
            class: "topic-card-breakdown-header",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showBreakdown = !_ctx.showBreakdown))
          }, [
            _hoisted_7,
            _createElementVNode("div", null, [
              (_ctx.showBreakdown)
                ? (_openBlock(), _createElementBlock("img", _hoisted_8))
                : (_openBlock(), _createElementBlock("img", _hoisted_9))
            ])
          ]),
          _createVNode(_Transition, { name: "fade" }, {
            default: _withCtx(() => [
              (_ctx.showBreakdown)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, _toDisplayString((
                                    (_ctx.topicResponseCount / _ctx.totalResponseCount) *
                                    100
                                ).toFixed(0)) + "% of all responses ", 1),
                    _createElementVNode("div", {
                      style: _normalizeStyle(_ctx.getBreakdownLineBg),
                      class: "topic-card-breakdown-line"
                    }, null, 4),
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", null, [
                        _createElementVNode("div", null, [
                          _hoisted_13,
                          _createTextVNode(" " + _toDisplayString(_ctx.positiveLabel), 1)
                        ]),
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.positiveCount), 1),
                          _createElementVNode("div", null, _toDisplayString(_ctx.positivePercent) + "%", 1)
                        ])
                      ]),
                      _createElementVNode("div", null, [
                        _createElementVNode("div", null, [
                          _hoisted_16,
                          _createTextVNode(" " + _toDisplayString(_ctx.neutralLabel), 1)
                        ]),
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.neutralCount), 1),
                          _createElementVNode("div", null, _toDisplayString(_ctx.neutralPercent) + "%", 1)
                        ])
                      ]),
                      _createElementVNode("div", null, [
                        _createElementVNode("div", null, [
                          _hoisted_19,
                          _createTextVNode(" " + _toDisplayString(_ctx.negativeLabel), 1)
                        ]),
                        _createElementVNode("div", _hoisted_20, [
                          _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.negativeCount), 1),
                          _createElementVNode("div", null, _toDisplayString(_ctx.negativePercent) + "%", 1)
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ], undefined, true),
            _: 1
          })
        ])
      ])
    ], undefined, true),
    _: 1
  }))
}